import React from 'react'
import Table from 'react-bootstrap/Table'
import filter_new from '../assets/img/filter_new.svg'
import dropdown from '../assets/img/dropdown.svg'
import forward_arrow from '../assets/img/forward_arrow.svg'
import Off from '../assets/img/Off.svg'
import tag from '../assets/img/tag.svg'
import tick from '../assets/img/tick.svg'
import close_sm from '../assets/img/close_sm.svg'
import Recomendacion from '../assets/img/Recomendacion.svg'
import recomendacion_alza from '../assets/img/recomendacion_alza.svg'
import No from '../assets/img/No.svg'
import Si from '../assets/img/Si.svg'

export const SeguimientoTableTr = ({
	class_css,
	hopeJson,
	codeProduct,
	traditional,
}) => {

	const product = traditional
		? hopeJson?.data_rows.find(
				(product) => product.product_code === codeProduct
		  )
		: hopeJson?.data_rows.find(
				(product) => product.product_code.includes(codeProduct)
		  )

	console.log('product', product)

	// try {
	// 	dataRowInicial = hopeJson.data_rows.inicial.filter(function (element) {
	// 		return element.code_product == codeProduct
	// 	})[0]

	// 	dataRowColaborativa = hopeJson.data_rows.colaborativa.filter(function (
	// 		element
	// 	) {
	// 		return element.code_product == codeProduct
	// 	})[0]

	// 	dataRowNegociacion = hopeJson.data_rows.negociacion.filter(function (
	// 		element
	// 	) {
	// 		return element.code_product == codeProduct
	// 	})[0]

	// 	dataRowEjecucion = hopeJson.data_rows.ejecucion.filter(function (element) {
	// 		return element.code_product == codeProduct
	// 	})[0]

	// 	console.log('Table TR PRODUCTO-----------')
	// 	console.log(dataRowInicial)
	// } catch (e) {
	// 	console.log('Se salta.... error')
	// 	return <></>
	// }

	const CapitalizeFirstLetter = (str) => {
		const arr = String(str).toLowerCase().split(' ')
		for (var i = 0; i < arr.length; i++) {
			arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
		}
		const str2 = arr.join(' ')
		return str2
	}

	return (
		<tr className={'activate ' + class_css}>
			<td>
				<div className='display_flex gray'>
					<p>{product?.subfamily}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<p>{product?.short_brand}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					{product?.recommendation === 0 && <img src={Recomendacion} alt='' />}
					{product?.recommendation === 1 && (
						<img src={recomendacion_alza} alt='' />
					)}
					{product?.recommendation === 2 && <img src={tag} alt='' />}
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<a href='#'>{product?.product_code}</a>
				</div>
			</td>
			<td>
				<div className='display_flex  gray'>
					<p>{CapitalizeFirstLetter(product?.product_description)}</p>
				</div>
			</td>

			<td>
				<div className='display_flex gray'>
					<p>
						{traditional
							? `${product?.offices_data_rows?.length} Of.`
							: `$${product?.base_price}`}
					</p>
				</div>
			</td>

			<td>
				<div className='display_flex gray'>
					<p>${`${product?.act_price}`}</p>
				</div>
			</td>
			<td>
				<div className='display_flex   green'>
					<p>${`${product?.opt_price}`}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<p>${product?.inicial?.prop_price}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<p>{product?.inicial?.discount}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<p>${product?.colaborativa?.prop_price}</p>
				</div>
			</td>
			<td>
				<div className='display_flex gray'>
					<p>{product?.colaborativa.discount}</p>
					{product?.colaborativa.icon === 'check' && <img src={tick} alt='' />}
					{product?.colaborativa.icon === 'x' && <img src={close_sm} alt='' />}
				</div>
			</td>

			<td>
				<div className='display_flex gray'>
					<p>${product?.negociacion?.prop_price}</p>
				</div>
			</td>

			<td>
				<div className='display_flex gray'>
					<p>{product?.negociacion?.discount}</p>
					{product?.negociacion.icon === 'check' && <img src={tick} alt='' />}
					{product?.negociacion.icon === 'x' && <img src={close_sm} alt='' />}
				</div>
			</td>
			<td>
				<div className='display_flex  gray'>
					<p>${product?.ejecucion?.prop_price}</p>
				</div>
			</td>
			<td>
				<div className='display_flex  gray'>
					<p>{product?.ejecucion?.discount}</p>
					{product?.ejecucion.icon === 'check' && <img src={tick} alt='' />}
					{product?.ejecucion.icon === 'x' && <img src={close_sm} alt='' />}
				</div>
			</td>
		</tr>
		// <tr className={'activate ' + class_css}>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>-</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>{dataRowInicial.brand}</p>
		// 		</div>
		// 	</td>

		// <td>
		// 	<div className='display_flex gray'>
		// 		<img src={Si} alt='' />
		// 		<img src={tag} alt='' />
		// 	</div>
		// </td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<a href='#'>{dataRowInicial.code_product}</a>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex  gray'>
		// 			<p>{dataRowInicial.current_description_product}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>${dataRowInicial.base_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>${dataRowInicial.current_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex   green'>
		// 			<p>${dataRowInicial.current_optimization_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>${dataRowInicial.proposed_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>{dataRowInicial.discount}%</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>${dataRowColaborativa.proposed_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex gray'>
		// 			<p>{dataRowColaborativa.discount}%</p> <img src={tick} alt='' />
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex  gray'>
		// 			<p>${dataRowNegociacion.proposed_price}</p>
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex  gray'>
		// 			<p>{dataRowNegociacion.discount}%</p> <img src={tick} alt='' />
		// 		</div>
		// 	</td>
		// 	<td>
		// 		<div className='display_flex  gray'>
		// 			<p>${dataRowEjecucion.proposed_price}</p>
		// 		</div>
		// 	</td>

		// 	<td>
		// 		<div className='display_flex  gray'>
		// 			<p>{dataRowEjecucion.discount}%</p>
		// 			<img src={tick} alt='' />
		// 		</div>
		// 	</td>
		// </tr>
	)
}
